/**
 * A count the server reported, or null when it reported none.
 *
 * The admin billing surfaces read per-queue counts off summary objects the
 * server may not have caught up with (GDN-4023: `claims_bill_secondary` and
 * the `bill_secondary` key arrive with smartscribe-server GDN-4022). A key the
 * server did not send is an unknown, not a zero, and a surface that printed
 * 0 for it would be stating a fact it does not have — the same rule JotBill
 * Home applies to its own counts.
 */
export function reportedCount(value: unknown): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}
